//removeIf(production)
import ClaroluzEventDispatch from "../../../../../infra/services/claroluz-event-dispatch";
import ClaroluzAlerts from "../../shared/alert/alerts.4";
//endRemoveIf(production)

class ClaroluzTypeChange {
    public type: string | false;
    public persistError: boolean;

    constructor(type?: string, persistError?: boolean) {
        this.type = type ?? false;
        this.persistError = persistError ?? false;

        this.changeType();
    }

    private changeType() {
        const uploader = document.querySelector('.claroluz-uploader') as HTMLElement;
        let currentType;
        let newType;

        if (uploader.classList.contains('type-qr')) {
            currentType = 'type-qr';
            newType = 'type-pdf';
        } else if (uploader.classList.contains('type-pdf')) {
            currentType = 'type-pdf';
            newType = 'type-cups';
        } else if (uploader.classList.contains('type-cups')) {
            currentType = 'type-cups';
        } else {
            throw new Error('ClaroluzTypeChange: Invalid type');
        }

        if (this.type === currentType) {
            return;
        }

        if (this.type) {
            switch (this.type) {
                case 'type-qr':
                    this.toQrCode();
                    break;
                case 'type-pdf':
                    this.toPdf();
                    break;
                case 'type-cups':
                    this.toCups();
                    break;
                default:
                    throw new Error('ClaroluzTypeChange: Invalid type');
            }

            return;
        }

        switch (newType) {
            case 'type-qr':
                this.toQrCode();
                break;
            case 'type-pdf':
                this.toPdf();
                break;
            case 'type-cups':
                this.toCups();
                break;
        }
    }

    private toQrCode() {
        let uploader = document.querySelector('.claroluz-uploader');

        if (!uploader) {
            throw new Error('No uploader found');
        }

        this.removeError();

        if (uploader.classList.contains('type-pdf')) {
            uploader.classList.remove('type-pdf');
        }

        if (uploader.classList.contains('type-cups')) {
            uploader.classList.remove('type-cups');
        }

        uploader.classList.add('type-qr');
        this.resetAll();
    }

    private toPdf() {
        let uploader = document.querySelector('.claroluz-uploader');

        if (!uploader) {
            throw new Error('No uploader found');
        }

        this.removeError();

        if (uploader.classList.contains('type-qr')) {
            uploader.classList.remove('type-qr');
        }

        if (uploader.classList.contains('type-cups')) {
            uploader.classList.remove('type-cups');
        }

        uploader.classList.add('type-pdf');
        this.resetAll();
    }

    private toCups() {
        let uploader = document.querySelector('.claroluz-uploader');

        if (!uploader) {
            throw new Error('No uploader found');
        }

        this.removeError();

        if (uploader.classList.contains('type-qr')) {
            uploader.classList.remove('type-qr');
        }

        if (uploader.classList.contains('type-pdf')) {
            uploader.classList.remove('type-pdf');
        }

        uploader.classList.add('type-cups');
        this.resetAll();
    }

    private removeError() {
        if (this.persistError) {
            return;
        }

        let uploader = document.querySelector('.claroluz-uploader')!;
        let checkbox = uploader.querySelector('.claroluz-checkbox')!;

        if (uploader.classList.contains('has-error')) {
            uploader.classList.remove('has-error');
        }

        ClaroluzAlerts.hide();

        if (checkbox.classList.contains('has-error')) {
            checkbox.classList.remove('has-error');
        }
    }

    private resetAll() {
        new ClaroluzEventDispatch('claroluz_reset');
    }
}

//removeIf(production)
export default ClaroluzTypeChange;
//endRemoveIf(production)